import Select from 'react-select';
import { Input } from 'reactstrap';
import React, { useState, useEffect } from 'react';
import { APIClient } from '../../helpers/api_helper';

export const SelectInputWithSearchApiAssociates = ({
  invalid,
  validation,
  setValue = () => {},
  handleChange = () => {},
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);

  const api = new APIClient();
  let timeoutId;

  const loadAssociate = async (search) => {
    setLoading(true);
    const response = await api.get(`/customer/incremental-search?q=${search}`);
    const result = response;
    setOptions(
      await result.map((permission) => ({
        label: permission.text,
        value: permission.id,
      }))
    );
    setLoading(false);
  };

  const handleInputChange = (search) => {
    setSearchTerm(search);
  };

  function loadTimeout() {
    if (searchTerm) {
      timeoutId = setTimeout(() => {
        if (searchTerm.length > 3) {
          loadAssociate(searchTerm);
        } else {
          setOptions([]);
        }
      }, 1000);
    }
  }

  useEffect(() => {
    // Cancelar a requisição anterior, se houver
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Agendar uma nova requisição após 500 milissegundos
    loadTimeout();

    // Limpar o timeout quando o componente for desmontado
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm, timeoutId]);

  const styles = {
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      height: 20,
      marginLeft: -10,
    }),
  };

  return (
    <Input
      tag={Select}
      styles={styles}
      invalid={invalid}
      noOptionsMessage={() => 'Sem resultado!'}
      isClearable={true}
      placeholder="Pesquise por nome, CPF ou N° da proposta"
      value={validation.values.searchInput}
      onInputChange={handleInputChange}
      loadingMessage={() => 'Carregando...'}
      isLoading={loading}
      onChange={(e) => {
        const event = {
          target: {
            name: 'searchInput',
            value: e,
          },
        };
        setValue(e);
        validation.handleChange(event);
        handleChange(e);

        if (!e) {
          setOptions([]);
          setValue('');
        }
      }}
      onBlur={validation.handleBlur}
      options={options}
      inputId="searchInput"
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};
